import React from "react";

export const AuthContext = React.createContext(null)

export const CompanyAuthContext = React.createContext(null);